/* eslint-disable */
import { SampleBatch, AnalysisRequestSubject, emptyRequest } from '@/modules/analysis/models/analysisRequest';
import generateStoreSetters from '@/helpers/generateStoreSetters';
import { State, StateAnalysis } from './state';
import * as AnalysisRequestService from '@/modules/analysis/services/analysisRequestService';
import { AnalysisRequest } from '@/modules/analysis/models/analysisRequest';

const state = new State();

const store = {
  namespaced: true,
  state,
  mutations: {
    ...generateStoreSetters(state),
    clearState: (stateAnalysis: StateAnalysis): void => {
      stateAnalysis = new State();
    },
    setNewRequestSubject: (stateAnalysis: StateAnalysis, subject: AnalysisRequestSubject): void => {
      stateAnalysis.newRequest.subject = subject;
    },
    resetNewRequest: (stateAnalysis: StateAnalysis): void => {
      stateAnalysis.newRequest = emptyRequest();
    },
    addBatchToNewRequest: (stateAnalysis: StateAnalysis, batch: SampleBatch): void => {
      const newRequest = stateAnalysis.newRequest;
      newRequest.sampleBatches.push(batch);
    },
    editBatchToNewRequest: (stateAnalysis: StateAnalysis, batchParam: { index: number; batch: SampleBatch }): void => {
      const newRequest = stateAnalysis.newRequest;
      newRequest.sampleBatches[batchParam.index] = batchParam.batch;
    },
    deleteBatchToNewRequest: (stateAnalysis: StateAnalysis, index: number): void => {
      const newRequest = stateAnalysis.newRequest;
      if (index > -1) {
        newRequest.sampleBatches.splice(index, 1);
      }
    }
  },
  actions: {
    initializeAnalyzes(storeParam: any, params?: { status?: string | undefined; offset?: string | undefined }): void {
      let analysisRequestsList: Array<AnalysisRequest> = [];
      AnalysisRequestService.fetchAll(params).then((res) => {
        for (const request of res.data) {
          analysisRequestsList.push(request);
        }
        storeParam.commit('setAnalysisRequestsList', analysisRequestsList);
      });
    },
    moreAnalyzes(
      storeParam: any,
      params?: { status?: string | undefined; offset?: string | undefined }
    ): Promise<boolean> {
      let analysisRequestsList: Array<AnalysisRequest> = storeParam.state.analysisRequestsList;
      let isMoreAnalysis = false;
      return new Promise((resolve, reject) => {
        AnalysisRequestService.fetchAll(params).then(
          (res) => {
            for (const request of res.data) {
              if (!analysisRequestsList.some((req) => req.id === request.id)) {
                analysisRequestsList.push(request);
                isMoreAnalysis = true;
              }
            }
            storeParam.commit('setAnalysisRequestsList', analysisRequestsList);
            resolve(isMoreAnalysis);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    readAnalysisRequest(storeParam: any, idParam: string): Promise<AnalysisRequest> {
      return new Promise((resolve, reject) => {
        for (const request of (storeParam.state as StateAnalysis).analysisRequestsList) {
          if (request.id === idParam && request.sampleBatches.length > 0) {
            resolve(request);
            return;
          }
        }
        AnalysisRequestService.read(idParam)
          .then((res) => resolve(res.data))
          .catch((e) => reject({ status: e.response.status, message: e.message }));
      });
    }
  },
  modules: {},
  getters: {}
};

export { store as analysis };
